import React, { Component } from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import Divider from 'material-ui/Divider';
import Paper from 'material-ui/Paper';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import CircularProgress from 'material-ui/CircularProgress';
import './Login.css';

class Login extends Component {
  state = {
    email: "",
    emailError: "",
    okEnabled: false,
    dialogOpen: false,
    guestName : "",
    waiting: false,
    loginSuccessful: false,
  };

  checkEmail = value => value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? 'Invalid email address.' : undefined

  submitEmail = (e) => {
    const emailError = this.checkEmail(this.state.email);

    if (emailError) {
     this.setState({emailError});
    } else {
     this.setState({emailError: ""});
    }
    if (emailError) {
      this.setState({okEnabled: false});
      return;
    }
    this.setState({okEnabled: false, waiting: true, dialogOpen: true});
    this.lookupUser(this.state.email);
  };

  lookupUser = (email) => {
    const url = `https://8ddxuiivkd.execute-api.us-east-1.amazonaws.com/production/login`
    const args = JSON.stringify({email: email})
    this.getCORS(url, 'POST', args, this.success);
  }


  getCORS = (url, method, args, success) => {
      var xhr = new XMLHttpRequest();
      xhr.open(method, url);
      xhr.onload = this.success;
      xhr.send(args);
      // this.success({currentTarget: {}, target: {responseText: "{\"first_name\": \"Joe\", \"email\": \"joe@example.com\"}"}});
      return xhr;
  }

  success = (response) => {
      var r = response.currentTarget.response || response.target.responseText;
      response = JSON.parse(r)
      if (response.first_name) {
        this.setState({loginSuccessful: true, guestName: JSON.parse(r).first_name, waiting: false});
      } else {
        this.setState({loginSuccessful: false, waiting: false});
      }

  };

  setEmail = (e, email) => {
    this.setState({email});
    this.setState({okEnabled: this.okEnabled({email})});
  };

  okEnabled = (currently) => {
    return (this.state.email !== "" || currently.email !== "");
  };

  handleClose = () => {
    this.setState({dialogOpen: false});
  };

  render() {
    const style = {
      marginLeft: 20,
    };

    const okDialogStyle = {
      width: '50%',
      maxWidth: '400px',
    };

    const actions = [
      <FlatButton
        label="OK"
        primary={true}
        onTouchTap={this.handleClose}
      />,
    ];

    const successMessage =
      <div className="message">
        <p>Hey <span>{this.state.guestName}</span>!</p>
        <p>We sent you an email at <span>{this.state.email}</span>. When you receive it, click on the link to fill out your RSVP.</p>
        <div className="signature"><div>❤️,</div>Alex and Hana.</div>
      </div>

    const failureMessage =
      <div className="message">
        <p>We couldn&#39;t find a guest associated with the email <span>{this.state.email}</span>. 😞</p>
        <p>You can try again. But, we also logged the request, so if we recognize you, you&#39;ll hear from us soon.</p>
        <p>Feel free to email us: <span>us@alexandhana.com</span>.</p>
        <div className="signature"><div>❤️,</div>Alex and Hana.</div>
      </div>

    return (
      <div className="Login">
        <MuiThemeProvider>
          <div className="login-form">
            <Paper zDepth={2}>
              <TextField hintText="Email address" floatingLabelText="Email address" style={style} underlineShow={false}
                onChange={this.setEmail} value={this.state.email} errorText={this.state.emailError}/>
              <Divider />
              <RaisedButton className="ok-button raised-button" primary={true} style={style} label="OK" onClick={this.submitEmail}
                 disabled={!this.state.okEnabled} />
              <Divider />
            </Paper>
            <Dialog actions={actions} modal={true} contentStyle={okDialogStyle} open={this.state.dialogOpen}>
              { this.state.waiting ? <CircularProgress /> : this.state.loginSuccessful ? successMessage : failureMessage }
            </Dialog>
          </div>
        </MuiThemeProvider>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/Login.js